 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about-us~become-content-provider~forgot-password~login~newsletter":"about-us~become-content-provider~forgot-password~login~newsletter","about-us":"about-us","become-content-provider":"become-content-provider","forgot-password":"forgot-password","login":"login","newsletter":"newsletter","account":"account","category-detail":"category-detail","gift":"gift","live-seminars":"live-seminars","my-videos":"my-videos","not-found":"not-found","npm.bootstrap-vue":"npm.bootstrap-vue","npm.popper.js":"npm.popper.js","npm.dinero.js":"npm.dinero.js","program-detail":"program-detail","npm.vue-functional-data-merge":"npm.vue-functional-data-merge","npm.algoliasearch":"npm.algoliasearch","search":"search","npm.stripe":"npm.stripe","subscribe":"subscribe","npm.dayjs":"npm.dayjs","profile":"profile","npm.mobile-device-detect":"npm.mobile-device-detect","download":"download","npm.swiper":"npm.swiper","npm.dom7":"npm.dom7","npm.ssr-window":"npm.ssr-window","npm.vue-awesome-swiper":"npm.vue-awesome-swiper","main":"main","privacy-policy~terms":"privacy-policy~terms","privacy-policy":"privacy-policy","terms":"terms","programs":"programs","npm.video.js":"npm.video.js","npm.videojs":"npm.videojs","npm.videojs-vtt.js":"npm.videojs-vtt.js"}[chunkId]||chunkId) + "." + {"about-us~become-content-provider~forgot-password~login~newsletter":"2d4b113c","about-us":"689f507a","become-content-provider":"cbe0c1d6","forgot-password":"1b0949d3","login":"d5b58219","newsletter":"3a41ceb6","account":"00ae76d6","category-detail":"62a8744f","chunk-2d21097e":"56d428d5","chunk-748b7d67":"08f8d8f1","chunk-771b3629":"d2c22fa0","chunk-7720db6a":"f1239f48","gift":"bd8c76af","live-seminars":"ef671c5f","my-videos":"266f6c1d","not-found":"cee42a1d","npm.bootstrap-vue":"b3a70cbd","npm.popper.js":"336c67ab","npm.dinero.js":"c8bcb2c6","program-detail":"4e0ac3f4","npm.vue-functional-data-merge":"071b2ef7","npm.algoliasearch":"e1ecbad0","search":"3f591234","npm.stripe":"1a847ea0","subscribe":"793496b7","npm.dayjs":"de7ba999","chunk-5a9a6416":"247c0cdf","chunk-6b183961":"cb2d4f95","chunk-e3e01e8c":"ff431942","profile":"4f042907","npm.mobile-device-detect":"a30b42fa","download":"f1cc568a","npm.swiper":"6bf786fd","npm.dom7":"19a9e376","npm.ssr-window":"c91e0c93","npm.vue-awesome-swiper":"3b973b0a","main":"3f1aed62","privacy-policy~terms":"7521186b","privacy-policy":"5db59166","terms":"5242ecdb","programs":"b3950017","npm.video.js":"dc9a97e4","npm.videojs":"750b4d5a","npm.videojs-vtt.js":"5f6e84a0","chunk-1a2a36a8":"cd9c4e0c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"become-content-provider":1,"newsletter":1,"chunk-748b7d67":1,"chunk-771b3629":1,"chunk-7720db6a":1,"live-seminars":1,"program-detail":1,"subscribe":1,"chunk-6b183961":1,"chunk-e3e01e8c":1,"npm.swiper":1,"main":1,"privacy-policy~terms":1,"npm.video.js":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about-us~become-content-provider~forgot-password~login~newsletter":"about-us~become-content-provider~forgot-password~login~newsletter","about-us":"about-us","become-content-provider":"become-content-provider","forgot-password":"forgot-password","login":"login","newsletter":"newsletter","account":"account","category-detail":"category-detail","gift":"gift","live-seminars":"live-seminars","my-videos":"my-videos","not-found":"not-found","npm.bootstrap-vue":"npm.bootstrap-vue","npm.popper.js":"npm.popper.js","npm.dinero.js":"npm.dinero.js","program-detail":"program-detail","npm.vue-functional-data-merge":"npm.vue-functional-data-merge","npm.algoliasearch":"npm.algoliasearch","search":"search","npm.stripe":"npm.stripe","subscribe":"subscribe","npm.dayjs":"npm.dayjs","profile":"profile","npm.mobile-device-detect":"npm.mobile-device-detect","download":"download","npm.swiper":"npm.swiper","npm.dom7":"npm.dom7","npm.ssr-window":"npm.ssr-window","npm.vue-awesome-swiper":"npm.vue-awesome-swiper","main":"main","privacy-policy~terms":"privacy-policy~terms","privacy-policy":"privacy-policy","terms":"terms","programs":"programs","npm.video.js":"npm.video.js","npm.videojs":"npm.videojs","npm.videojs-vtt.js":"npm.videojs-vtt.js"}[chunkId]||chunkId) + "." + {"about-us~become-content-provider~forgot-password~login~newsletter":"31d6cfe0","about-us":"31d6cfe0","become-content-provider":"844fa631","forgot-password":"31d6cfe0","login":"31d6cfe0","newsletter":"a690ce5b","account":"31d6cfe0","category-detail":"31d6cfe0","chunk-2d21097e":"31d6cfe0","chunk-748b7d67":"f4457d5b","chunk-771b3629":"39a2421b","chunk-7720db6a":"712c469d","gift":"31d6cfe0","live-seminars":"1af87be1","my-videos":"31d6cfe0","not-found":"31d6cfe0","npm.bootstrap-vue":"31d6cfe0","npm.popper.js":"31d6cfe0","npm.dinero.js":"31d6cfe0","program-detail":"ff6a8c34","npm.vue-functional-data-merge":"31d6cfe0","npm.algoliasearch":"31d6cfe0","search":"31d6cfe0","npm.stripe":"31d6cfe0","subscribe":"f4fdded3","npm.dayjs":"31d6cfe0","chunk-5a9a6416":"31d6cfe0","chunk-6b183961":"8251e2a2","chunk-e3e01e8c":"a8cf941d","profile":"31d6cfe0","npm.mobile-device-detect":"31d6cfe0","download":"31d6cfe0","npm.swiper":"859f4391","npm.dom7":"31d6cfe0","npm.ssr-window":"31d6cfe0","npm.vue-awesome-swiper":"31d6cfe0","main":"e07fd44c","privacy-policy~terms":"61aa38ce","privacy-policy":"31d6cfe0","terms":"31d6cfe0","programs":"31d6cfe0","npm.video.js":"cc724262","npm.videojs":"31d6cfe0","npm.videojs-vtt.js":"31d6cfe0","chunk-1a2a36a8":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
